module.exports = __webpack_public_path__ + "img/download-app.5f2a8b7c.png";